export default __webpack_public_path__ + "static/media/spid-idp-namirialid.ab76af82.png";